// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var LockedContractsController = function ($scope, $http, LockedContract) {
    $scope.$on('refresh', function (event) { $scope.contracts = LockedContract.query(); });
    $scope.unlock = function (id) {
        $http.post('/api/v1/lockedContracts/' + id, {}).success(function () { $scope.contracts = LockedContract.query(); });
    };
};
LockedContractsController.$inject = ['$scope', '$http', 'LockedContract'];
